export const MessageSentToChatGroup = 'groupMessage-'
export const SendMessageToChatGroup = 'group-'
